import { useState } from 'react';

interface IPollCheckbox {
  option: string;
  handleMultipleChoiceChange: any;
  questionNum: number;
  answerNum: number;
  responses: any;
}

const PollCheckbox = ({ option, handleMultipleChoiceChange, questionNum, answerNum, responses }: IPollCheckbox) => {
  return (
    <label
      className={`w-full cursor-pointer flex gap-2 items-center ${
        responses[questionNum]?.[answerNum]
          ? 'bg-red-main text-white'
          : 'bg-black bg-opacity-5 hover:bg-opacity-10 text-black'
      } px-4 py-3 rounded-lg text-white`}
    >
      <input
        type="checkbox"
        checked={!!responses[questionNum]?.[answerNum]}
        onChange={() => {
          handleMultipleChoiceChange(questionNum, answerNum);
        }}
        className="mr-2 focus:ring-red-main bg-red-main focus:bg-red-main hidden"
      />
      {responses[questionNum]?.[answerNum] ? (
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 bg-red-main fill-white">
          <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8.29 13.29c-.39.39-1.02.39-1.41 0L5.71 12.7c-.39-.39-.39-1.02 0-1.41.39-.39 1.02-.39 1.41 0L10 14.17l6.88-6.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-7.58 7.59z"></path>
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 fill-red-main">
          <path d="M18 19H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zm1-16H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"></path>
        </svg>
      )}
      {option}
    </label>
  );
};

export default PollCheckbox;
